export const T = {
  en_GB: {
    // repNoteViaMember is a template filled by `fillRepresentativeTemplate` (@repo/shared).
    repNote: (name: string) =>
      `Questions concerning knowledge and experience are answered by ${name}, acting on behalf of the client.`,
    repNoteViaMember:
      "Questions concerning knowledge and experience are answered by {name} ({role}), on behalf of {member}, who acts for the group.",
    repGeneric: "the client's representative",
    adjustmentQuestions: "Adjustment Questions",
  },
  nb_NO: {
    repNote: (name: string) =>
      `Spørsmål som gjelder kunnskap og erfaring, besvares av ${name}, som handler på vegne av kunden.`,
    repNoteViaMember:
      "Spørsmål som gjelder kunnskap og erfaring, besvares av {name} ({role}), på vegne av {member}, som handler for gruppen.",
    repGeneric: "kundens representant",
    adjustmentQuestions: "Justeringsspørsmål",
  },
} as const;
